import {
  FilterId,
  GenericFilterOption,
  SearchFilterType,
  SearchNavBarSections,
} from '../../types/filters/filters';
import { FilterQueryParam } from '../../types/search/search';

interface GetInseamFilterConfigInputs {
  options?: GenericFilterOption[];
}

export const getInseamFilterConfig = (params?: GetInseamFilterConfigInputs) => {
  const { options = [] } = params || {};
  return {
    id: FilterId.Inseam,
    label: 'Inseam',
    type: SearchFilterType.Checkbox,
    group: 'primary',
    queryParamNames: [FilterQueryParam.inseam],
    searchNavBarSection: SearchNavBarSections.Filter,
    config: { options },
  };
};
